<template>
  <div class="content-bd">
    <!--核心优势速览：HR 首屏一眼可见，详细技能见下方技能区-->
    <div class="skill-overview">
      <span class="skill-overview-label">核心优势</span>
      <ul class="skill-overview-tags">
        <li class="ov-tag ov-tag-key">AI大模型应用</li>
        <li class="ov-tag ov-tag-key">RAG / Agent / MCP</li>
        <li class="ov-tag ov-tag-key">架构设计</li>
        <li class="ov-tag">业务梳理</li>
        <li class="ov-tag">系统集成</li>
        <li class="ov-tag">Spring AI / LangChain4j</li>
        <li class="ov-tag">SpringCloud</li>
        <li class="ov-tag ov-tag-key">Java 后端</li>
        <li class="ov-tag">微服务架构</li>
        <li class="ov-tag">Vue2 / Vue3</li>
        <li class="ov-tag">Ollama 私有化部署</li>
        <li class="ov-tag ov-tag-key">AI编程辅助开发</li>
        <li class="ov-tag ov-tag-honor">新疆自治区/兵团政采云专家</li>
        <li class="ov-tag ov-tag-honor">兵团科技专家</li>
        <li class="ov-tag ov-tag-honor">职称副高</li>
        <li class="ov-tag ov-tag-soft">沟通能力强</li>
        <li class="ov-tag ov-tag-soft">效率高</li>
      </ul>
    </div>
    <div class="content-left">
      <section class="practice">
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">工作经历</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd animate__animated animate__fadeInLeft">
          <!--经历:兵团文广传媒集团有限公司-->
          <div class="item">
            <header class="item-hd" @click="openOrClose(99)">
              <img
                class="open"
                :class="{ collapsed: !open[99] }"
                src="static/jian-xianxingyuankuang.svg"
              />
              <div class="company-des">
                <h3 class="item-name">兵团文广传媒集团有限公司-软件架构师</h3>
                <span class="item-time">2025.11 至今</span>
              </div>
              <a
                @click.stop
                class="btn item-more"
                href="https://baike.baidu.com/item/%E6%96%B0%E7%96%86%E7%94%9F%E4%BA%A7%E5%BB%BA%E8%AE%BE%E5%85%B5%E5%9B%A2%E6%96%87%E5%B9%BF%E4%BC%A0%E5%AA%92%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/51871507"
                target="_blank"
                title="点击查看->兵团文广传媒集团有限公司百度百科"
                >工作</a
              >
            </header>
            <ol
              :style="{ display: open[99] ? 'block' : 'none' }"
              class="item-project"
            >
              <li class="project-1">
                <h3 class="project-name">
                  <a href="/" target="_blank" title="点击进入->通义绘图首页"
                    >文广天书AI应用平台[独立负责 · 团队12人]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    SpringCloudAlibaba+mybatisPlus+vue3+ts架构。实现智能AI助手、知识库、智能创作图和视频、声音复刻、大模型接入与管理等功能模块，完成本地私有化部署大模型。
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及技术】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">SpringCloudAlibaba</el-tag>
                          <el-tag size="mini">通义大模型</el-tag>
                          <el-tag size="mini">OLLAMA</el-tag>
                          <el-tag size="mini">mybatisPlus</el-tag>
                          <el-tag size="mini">Vue3</el-tag>
                          <el-tag size="mini">TypeScript</el-tag>
                          <el-tag size="mini">Element UI</el-tag>
                          <el-tag size="mini">Nginx</el-tag>
                          <el-tag size="mini">SpringAI</el-tag>
                          <el-tag size="mini">langchain4j</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【工作职责】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <li>负责项目框架搭建以及疑难问题解决</li>
                          <li>负责设计整体模型管理和适配业务流程</li>
                          <li>负责设计与任务调度</li>
                          <li>负责设计与私有模型接入适配</li>
                          <li>统筹 12 人研发团队，主导任务拆解、排期与进度把控</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
              <li class="project-1">
                <h3 class="project-name">
                  <a
                    href="https://www.btzx.com.cn/"
                    target="_blank"
                    title="点击进入->省级融媒体平台"
                    >省级融媒体平台升级改造项目[技术架构负责人 · 团队20人]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    省级融媒体平台为十年前设计与实现的系统，原有架构与技术栈存在性能与扩展瓶颈。担任技术架构负责人，主导平台整体升级改造，统筹 20 人团队完成框架架构升级与业务梳理，并引入新媒体、AI 等能力赋能稿件生产全流程
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及技术】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">SpringBoot</el-tag>
                          <el-tag size="mini">MyBatis</el-tag>
                          <el-tag size="mini">Vue2</el-tag>
                          <el-tag size="mini">微服务</el-tag>
                          <el-tag size="mini">solr企业级检索</el-tag>
                          <el-tag size="mini">天翼云OSS</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【工作职责】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <li>担任技术架构负责人，统筹 20 人团队的技术分工与架构落地</li>
                          <li>主导整体技术方案选型、架构设计与部署方案评审</li>
                          <li>主导整体业务梳理、系统改版方案与疑难问题攻关</li>
                          <li>把控升级改造进度与质量风险，保障平台稳定平滑过渡</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
        <div class="section-bd animate__animated animate__fadeInLeft">
          <!--经历:数字新疆建设运营有限公司-->
          <div class="item">
            <header class="item-hd" @click="openOrClose(0)">
              <img
                class="open"
                :class="{ collapsed: !open[0] }"
                src="static/jian-xianxingyuankuang.svg"
              />
              <div class="company-des">
                <h3 class="item-name">数字新疆建设运营有限公司-研发工程师</h3>
                <span class="item-time">2025.03 至 2025.11 </span>
              </div>
              <a
                @click.stop
                class="btn item-more"
                href="https://aiqicha.baidu.com/company_detail_56107731310307"
                target="_blank"
                title="点击查看->数字新疆建设运营有限公司百度百科"
                >工作</a
              >
            </header>
            <ol
              :style="{ display: open[0] ? 'block' : 'none' }"
              class="item-project"
            >
              <li class="project-1">
                <h3 class="project-name">
                  <a
                    href="https://zwfw.xinjiang.gov.cn/"
                    target="_blank"
                    title="点击进入->省级融媒体平台"
                    >自治区政务一体化平台[研发组副组长 · 团队50人]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    参与自治区政务一体化平台建设和研发工作，作为研发组副组长统筹 50 人团队，主要梳理各厂家业务系统，进行业务集成和部分集成开发功能
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">业务梳理</el-tag>
                          <el-tag size="mini">系统集成</el-tag>
                          <el-tag size="mini">业务编排</el-tag>
                          <el-tag size="mini">集成开发</el-tag>
                          <el-tag size="mini">团队管理</el-tag>
                          <el-tag size="mini">需求对接</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【工作职责】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <li>担任研发组副组长，协助统筹 50 人研发团队的整体推进</li>
                          <li>负责功能拆解与任务分配，制定排期并把控交付进度</li>
                          <li>负责需求对接，主导业务梳理、系统边界划分与集成方案</li>
                          <li>参与项目框架设计以及疑难问题解决</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
        <div class="section-bd animate__animated animate__fadeInLeft">
          <!--经历:兵团文广传媒集团有限公司-->
          <div class="item">
            <header class="item-hd" @click="openOrClose(1)">
              <img
                class="open"
                :class="{ collapsed: !open[1] }"
                src="static/jian-xianxingyuankuang.svg"
              />
              <div class="company-des">
                <h3 class="item-name">兵团文广传媒集团有限公司-软件架构师</h3>
                <span class="item-time">2023.11 至 2025.03 </span>
              </div>
              <a
                @click.stop
                class="btn item-more"
                href="https://baike.baidu.com/item/%E6%96%B0%E7%96%86%E7%94%9F%E4%BA%A7%E5%BB%BA%E8%AE%BE%E5%85%B5%E5%9B%A2%E6%96%87%E5%B9%BF%E4%BC%A0%E5%AA%92%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/51871507"
                target="_blank"
                title="点击查看->兵团文广传媒集团有限公司百度百科"
                >工作</a
              >
            </header>
            <ol
              :style="{ display: open[1] ? 'block' : 'none' }"
              class="item-project"
            >
            </ol>
          </div>
          <!--经历:数字兵团产业发展有限公司-->
          <div class="item">
            <header class="item-hd" @click="openOrClose(2)">
              <img
                class="open"
                :class="{ collapsed: !open[2] }"
                src="static/jian-xianxingyuankuang.svg"
              />
              <div class="company-des">
                <h3 class="item-name">
                  新疆数字兵团信息产业发展有限责任公司-Java开发工程师
                </h3>
                <span class="item-time">2022.05 至 2023.10</span>
              </div>
              <a
                @click.stop
                class="btn item-more"
                href="https://baike.baidu.com/item/%E6%96%B0%E7%96%86%E6%95%B0%E5%AD%97%E5%85%B5%E5%9B%A2%E4%BF%A1%E6%81%AF%E4%BA%A7%E4%B8%9A%E5%8F%91%E5%B1%95%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8/51414057?fr=aladdin"
                target="_blank"
                title="点击查看->数字兵团产业发展有限公司百度百科"
                >工作</a
              >
            </header>
            <ol
              :style="{ display: open[2] ? 'block' : 'none' }"
              class="item-project"
            >
              <li class="project-1">
                <h3 class="project-name">
                  <a
                    href="https://www.paddlepaddle.org.cn/"
                    target="_blank"
                    title="点击进入->OCR核心首页"
                    >基于政务云平台的OCR技术研发及应用平台[独立负责 · 团队5人]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    SpringBoot+vue架构+飞桨开源深度学习PaddleOCR+政务云服务环境。实现OCR识别模型的训练与部署，将政务业务中涉及手写件、身份证、营业执照和车票等证照材料进行结构化识别，并利用政务网CPU环境完成部署，实现非结构化数据转结构化数据。
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及技术】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">SpringBoot</el-tag>
                          <el-tag size="mini">MyBatis</el-tag>
                          <el-tag size="mini">Vue2</el-tag>
                          <el-tag size="mini">Element UI</el-tag>
                          <el-tag size="mini">Nginx</el-tag>
                          <el-tag size="mini">docker</el-tag>
                          <el-tag size="mini">飞桨开源深度学习</el-tag>
                          <el-tag size="mini">Python3</el-tag>
                          <el-tag size="mini">模型训练</el-tag>
                          <el-tag size="mini">图片标注</el-tag>
                          <el-tag size="mini">PaddleOCR</el-tag>
                          <el-tag size="mini">政务云</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【工作职责】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <li>负责项目框架搭建以及疑难问题解决</li>
                          <li>负责设计整体识别业务流程</li>
                          <li>
                            负责研究飞桨文字识别PaddleOCR模型训练、部署、调用
                          </li>
                          <li>负责实现OCR识别前端平台搭建</li>
                          <li>负责实现OCR识别后端spring boot服务搭建</li>
                          <li>
                            负责实现OCR识别通用识别、单文件识别、多文件识别模式
                          </li>
                          <li>
                            负责实现OCR识别类型手写件、身份证、营业执照和车票
                          </li>
                          <li>负责实现政务云环境搭建和服务架构</li>
                          <li>负责申报软件软著</li>
                          <li>统筹 5 人研发团队，主导任务分工与交付进度</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>

              <li class="project-1">
                <h3 class="project-name">
                  <a
                    href="/"
                    target="_blank"
                    title="点击进入->多师市数据驾驶舱平台"
                    >多师市政务服务数据驾驶舱平台[技术负责人 · 团队10人]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    SpringBoot+vue架构+ECharts+大数据平台+政务云服务环境。实现对接大数据平台将师市政务数据实时展示，共8个师市大屏数据驾驶舱。
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及技术】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">SpringBoot</el-tag>
                          <el-tag size="mini">MyBatis</el-tag>
                          <el-tag size="mini">Vue2</el-tag>
                          <el-tag size="mini">Element UI</el-tag>
                          <el-tag size="mini">Nginx</el-tag>
                          <el-tag size="mini">ECharts</el-tag>
                          <el-tag size="mini">大数据平台</el-tag>
                          <el-tag size="mini">政务云</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【工作职责】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <li>负责项目框架搭建以及疑难问题解决</li>
                          <li>负责设计整体数据业务流程</li>
                          <li>参与实现数据驾驶舱前端平台</li>
                          <li>负责实现数据驾驶舱管理端平台搭建</li>
                          <li>负责实现数据驾驶舱后端服务搭建</li>
                          <li>负责实现对接大数据平台政务展示基础数据</li>
                          <li>负责实现政务云环境搭建和服务架构</li>
                          <li>担任技术负责人，统筹 10 人团队的技术方案与交付</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
              <li class="project-1">
                <h3 class="project-name">
                  <a href="/" target="_blank" title="点击进入->星火·链网首页"
                    >兵团国垂一体化系统 [独立负责 · 团队7人]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    SpringBoot+MyBatis+MySQL+Nginx+政务云服务环境。完成与国家国垂管理系统对接，实现事项接入申请、办件过程与结果数据同步，及兵团地方平台与国务院部门垂管系统业务数据回传和业务协同，逐步解决兵团地方平台“一窗受理”政务服务改革需求。
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及技术】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">SpringBoot</el-tag>
                          <el-tag size="mini">MyBatis</el-tag>
                          <el-tag size="mini">Nginx</el-tag>
                          <el-tag size="mini">ECharts</el-tag>
                          <el-tag size="mini">政务云</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【工作职责】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <li>负责项目框架搭建以及疑难问题解决</li>
                          <li>负责完成与国家国垂管理系统对接，实现事项接入申请</li>
                          <li>负责实现办件过程与结果数据同步</li>
                          <li>负责设计整体数据对接业务流程</li>
                          <li>负责实现数据对接接口加密解密</li>
                          <li>负责实现数据XML、JSON解析</li>
                          <li>负责实现数据对接统计对账功能</li>
                          <li>负责实现集群架构部署</li>
                          <li>统筹 7 人研发团队，主导技术方案与进度把控</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
              <li class="project-1">
                <h3 class="project-name">
                  <a href="/" target="_blank" title="点击进入->兵团本级一体化政务服务平台"
                    >兵团本级一体化政务服务平台 [参与]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    参与兵团本级一体化政务服务平台建设，完成兵团政务一期项目部分建设与验收工作，负责兵团政务网的研发与安全运营，熟悉政务一体化各业务系统。
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及技术】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">SpringBoot</el-tag>
                          <el-tag size="mini">MyBatis</el-tag>
                          <el-tag size="mini">Vue2</el-tag>
                          <el-tag size="mini">政务一体化</el-tag>
                          <el-tag size="mini">安全运营</el-tag>
                          <el-tag size="mini">漏洞修复</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【工作职责】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <li>参与兵团政务一期项目部分建设与验收工作</li>
                          <li>负责兵团政务网的研发与安全运营</li>
                          <li>协助事项梳理、办件同步等业务对接</li>
                          <li>负责政务网服务器部署与安全漏洞修复</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </div>

          <!--经历:绿洲驼铃项目-->
          <div class="item">
            <header class="item-hd" @click="openOrClose(3)">
              <img
                class="open"
                :class="{ collapsed: !open[3] }"
                src="static/jian-xianxingyuankuang.svg"
              />
              <div class="company-des">
                <h3 class="item-name">
                  新疆绿洲驼铃农业发展有限公司-软件开发工程师
                </h3>
                <span class="item-time">2022.01 至 2022.05</span>
              </div>
              <a
                @click.stop
                class="btn item-more"
                target="_blank"
                title="点击查看->新疆绿洲驼铃农业发展有限公司百度百科"
                >工作</a
              >
            </header>
            <ol
              :style="{ display: open[3] ? 'block' : 'none' }"
              class="item-project"
            >
              <li class="project-1">
                <h3 class="project-name">
                  <a
                    href="/"
                    target="_blank"
                    title="点击进入->绿洲农场运营平台首页"
                    >绿洲农场运营平台 [核心开发]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    SpringCloudAlibaba框架搭建项目,项目服务于公司绿洲农场及其他农户对土地的种植周期管理、种植解决方案、农产品销售和农产品销售管理一体化管理，形成绿洲驼铃农业全产业链运营服务解决方案。
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及技术】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">SpringCloud2021</el-tag>
                          <el-tag size="mini">Spring Boot</el-tag>
                          <el-tag size="mini">XXL-JOB</el-tag>
                          <el-tag size="mini">Nacos</el-tag>
                          <el-tag size="mini">Spring Cloud Loadbalancer</el-tag>
                          <el-tag size="mini">Sentinel</el-tag>
                          <el-tag size="mini">Spring Cloud Gateway</el-tag>
                          <el-tag size="mini">Logback</el-tag>
                          <el-tag size="mini">Seata</el-tag>
                          <el-tag size="mini">RocketMq</el-tag>
                          <el-tag size="mini">Activiti</el-tag>
                          <el-tag size="mini">MySQL</el-tag>
                          <el-tag size="mini">Redis</el-tag>
                          <el-tag size="mini">MyBatis Plus</el-tag>
                          <el-tag size="mini">Druid</el-tag>
                          <el-tag size="mini">Vue2</el-tag>
                          <el-tag size="mini">ECharts</el-tag>
                          <el-tag size="mini">ElementUI</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【工作职责】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <li>参与项目框架扩展以及疑难问题解决</li>
                          <li>参与设计农产品商城业务流程</li>
                          <li>负责实现农产品APP商城后端服务</li>
                          <li>负责实现农产品商城管理前后端</li>
                          <li>负责接入微信支付与支付宝支付</li>
                          <li>
                            负责接入农场设备的管理与采集数据（虫情仪、气象站、墒情仪等）
                          </li>
                          <li>参与实现农场种植管理、解决方案等种植业务环节</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
          <!--经历:昆仑卫士-->
          <div class="item">
            <header class="item-hd" @click="openOrClose(4)">
              <img
                class="open"
                :class="{ collapsed: !open[4] }"
                src="static/jian-xianxingyuankuang.svg"
              />
              <div class="company-des">
                <h3 class="item-name">
                  新疆昆仑卫士信息科技有限公司-Java开发工程师
                </h3>
                <span class="item-time">2020.03 至 2021.08</span>
              </div>
              <a
                @click.stop
                class="btn item-more"
                href="https://baike.baidu.com/item/%E8%A5%BF%E5%AE%89%E7%BB%BF%E8%B1%86%E8%8A%BD%E4%BF%A1%E6%81%AF%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8"
                target="_blank"
                title="点击查看->新疆昆仑卫士信息科技有限公司百度百科"
                >工作</a
              >
            </header>
            <ol
              :style="{ display: open[4] ? 'block' : 'none' }"
              class="item-project"
            >
              <li class="project-1">
                <h3 class="project-name">
                  <a
                    href="http://www.bitchang.com"
                    target="_blank"
                    title="点击进入->红山通APP首页"
                    >红山通APP [核心开发]</a
                  >
                </h3>
                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    红山通APP业务涉及乌鲁木齐线上扫码乘公交车、NFC卡片充值、便民业务（缴电费、民生缴费、实时公交等）、扣费，订单，充值，提现、与各大银行或公共平台对接扫码乘车、与设备间密钥传输，生成，同步等业务。
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">线上实时公交模块</h3>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>负责接入公交设备服务商公交实时数据</li>
                          <li>负责接入市区公交站点、线路基础信息</li>
                          <li>负责实现站点查询、线路查询功能</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">红山通线上运营监控模块</h3>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>负责集成集成企业微信，进行实时推送消息</li>
                          <li>负责实现监控线上各业务、各密钥等功能状态</li>
                          <li>负责实现企业微信作为通知平台实时监控业务</li>
                          <li>负责实现一键查询业务状态功能</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">红山通对账模块</h3>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>
                            负责实现统计线上各类包括充值、乘车、电费缴纳、提现等订单
                          </li>
                          <li>负责实现账目合计功能</li>
                          <li>负责实现统计公交公司统计量报表接口</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">电网缴费模块</h3>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>负责实现电网缴费订单功能</li>
                          <li>负责实现电网付费完成后支付回调功能</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">招行小程序Vue开发</h3>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>负责实现招行乘车小程序的登录功能和页面</li>
                          <li>负责实现公交月卡充值功能和页面</li>
                          <li>负责实现提现和余额充值功能和页面</li>
                          <li>参与实现展示乘车二维码</li>
                          <li>参与实现NFC卡片充值功能</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">其他</h3>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>负责实现ELK日志集成</li>
                          <li>负责实现nginx代理配置</li>
                          <li>负责实现Linux服务器部署</li>
                          <li>
                            红山通开发和运营期间，负责红山通的部署、统计数据、密钥同步、与中行对接扫码乘车
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </div>

          <!--经历:实习-->
          <div class="item">
            <header class="item-hd" @click="openOrClose(5)">
              <img
                class="open"
                :class="{ collapsed: !open[5] }"
                src="static/jian-xianxingyuankuang.svg"
              />
              <div class="company-des">
                <h3 class="item-name">大连东软集团</h3>
                <span class="item-time">2019.06 至 2019.11</span>
              </div>
              <a
                @click.stop
                class="btn item-more"
                target="_blank"
                title="点击查看->大连东软集团百度百科"
                >实习工作</a
              >
            </header>
            <ol
              :style="{ display: open[5] ? 'block' : 'none' }"
              class="item-project"
            >
              <li class="project-1">
                <h3 class="project-name">
                  <a
                    href="/"
                    target="_blank"
                    title="点击进入->东软家电物联网智测平台系统首页"
                    >东软家电物联网智测平台系统 [核心开发]</a
                  >
                </h3>

                <div class="div-project-item">
                  <h3 class="project-des">【项目简介】</h3>
                  <p class="item-project-des">
                    该项目架构为SpringBoot框架；项目业务流程为设置工具连接，路由器连接脚本手机端Android,
                    ios脚本自动连接，完成智能家居设备自动化测试；主要负责连接工具的开发。项目的路由器连接脚本、
                    手机端Android,
                    ios脚本的编写，脚本主要用到Java编写的selenium和appnium。部署到
                    springboot项目中，解决脚本执行功能。
                  </p>
                </div>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">【涉及技术】</h3>
                      <div class="div-item">
                        <ul class="section-content">
                          <el-tag size="mini">SpringBoot</el-tag>
                          <el-tag size="mini">Selenium(Java)</el-tag>
                          <el-tag size="mini">Appium(Java)</el-tag>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>
                            参与项目框架搭建以及疑难问题解决，为项目成员提供开发思路
                          </li>
                          <li>负责实现网页端自动连接路由器脚本</li>
                          <li>负责实现手机Android端自动绑定智能电器</li>
                          <li>负责实现手机IOS端自动绑定智能电器</li>
                          <li>负责实现Selenium和Appium接入项目框架</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </section>
    </div>
    <div class="content-right">
      <section class="skill">
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">技能</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd animate__animated animate__fadeInRight">
          <!--技能:AI大模型（核心竞争力，前置）-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">AI大模型应用开发</span>
              <a class="btn item-more-right">熟练掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>
                  基于 Spring AI / LangChain4j 构建企业级 AI 应用，独立负责「文广天书 AI 应用平台」整体架构设计与落地
                </li>
                <li>
                  熟练实践 RAG 检索增强生成：知识库构建、文档切分、Embedding 模型选型、向量检索与召回调优
                </li>
                <li>
                  熟悉 Agent、Function Calling、MCP 协议，能进行工具调用编排与多步推理应用开发
                </li>
                <li>
                  熟悉多模态生成业务封装：文生图、文生视频、声音复刻、智能创作等场景的接入与实现
                </li>
                <li>
                  使用 Ollama 完成 LLM / Qwen 等大模型本地私有化部署与运维
                </li>
                <li>
                  设计统一的大模型接入管理与适配层，屏蔽通义、私有模型等多家厂商差异
                </li>
                <li>
                  熟悉飞桨 PaddlePaddle、Paddle Serving、PaddleOCR 模型训练、调优、部署
                </li>
                <li>熟悉 Python3，具备模型训练、数据标注到上线的完整经验</li>
              </ul>
            </div>
          </div>

          <!--技能:Java后端开发-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">Java后端开发</span>
              <a class="btn item-more-right">熟练掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>近七年Java后端实际开发经验（含实习），掌握Java面向对象思想编程</li>
                <li>
                  熟练使用SpringMVC、Spring Boot、Spring
                  Cloud等主流框架，熟悉Restful 风格API设计
                </li>
                <li>
                  熟练使用数据库操作框架Hibernate JPA，MyBatis&&MyBatis
                  Plus，熟悉掌握SQL语句
                </li>
                <li>
                  熟练使用Websocket，并使用websocket进行服务端与客户端实时数据传输
                </li>
                <li>熟练使用Jwt等用户鉴权产品</li>
                <li>熟练使用Docker容器部署和安装</li>
                <li>
                  熟练使用非关系型数据库Redis、MongoDB等，有Redis实际项目开发使用经验
                </li>
                <li>
                  熟练使用消息中间件Rabbit MQ、Rocket MQ等开源中间件，有Rocket
                  MQ实际项目开发使用经验
                </li>
                <li>
                  熟练使用Spring
                  cloud在企业大型应用中的应用，以及大型应用的微服务化及服务治理
                </li>
                <li>
                  熟练业务接口对接、加密处理（RSA，AES，银行类接口加密等）
                </li>
                <li>有政务、交通、农业行业独立工作经验</li>
              </ul>
            </div>
          </div>

          <!--数据库-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">数据库</span>
              <a class="btn item-more-right">熟练掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>
                  熟悉关系型数据库技术，熟练使用关系型数据库Mysql、Oracle、SqlServer
                </li>
                <li>
                  熟悉非关系型数据库技术，熟练使用非关系型数据库Nosql：Redis
                </li>
                <li>
                  熟练使用ORM数据库操作框架使用
                </li>
                <li>熟练解决并发业务，多线程业务</li>
                <li>熟练排查数据库sql等异常问题</li>
                <li>
                  了解分库分表ShardingSphere、分布式数据库及Mycat中间件，并正致力于提高分布式数据库能力和对于数据库高并发高可用
                </li>
              </ul>
            </div>
          </div>

          <!--服务器|架构-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">服务器|架构</span>
              <a class="btn item-more-right">熟练掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>熟练掌握Nginx、Tomcat、Apache服务器使用</li>
                <li>
                  熟练掌握常用软件（MySQL、Redis、Rabbit
                  MQ等）在服务器的搭建与使用
                </li>
                <li>熟练使用Centos(Linux)云服务器并掌握线上环境和应用的部署</li>
                <li>熟悉Docker和docker-compose应用部署</li>
                <li>
                  熟练Java架构、大数据架构、数据集成架构、AI模型训练架构、移动端架构
                </li>
                <li>熟悉微服务、高并发、高可用集群服务端架构</li>
                <li>熟练掌握Git、GitLab、maven等工具使用</li>
              </ul>
            </div>
          </div>

          <!--WEB前端开发-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">WEB前端开发</span>
              <a class="btn item-more-right">掌握</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>有三个项目以上的VUE2，VUE3前端开发经验</li>
                <li>熟悉前端技术HTML、JS、CSS</li>
                <li>掌握网页弹性布局</li>
                <li>掌握前端流行ui element UI、Vant等</li>
                <li>
                  掌握前端大屏研发Echarts和DataV、地图（天地图和高德地图）
                </li>
                <li>熟悉移动端uniapp、原生小程序开发、云原生小程序开发</li>
                <li>
                  熟悉ts语法，vue3、Pinia开发
                </li>
              </ul>
            </div>
          </div>

          <!--独立开发-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">独立开发</span>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>有独立主导并负责的项目开发经验，在项目中可进行独立开发</li>
                <li>
                  有良好的编码习惯与编程思想，学习能力强，可快速学习新技术，对新技术、好技术热爱
                </li>
                <li>工作稳定性高，对公司负责，有一定的项目管理经验</li>
              </ul>
            </div>
          </div>

          <!--网络安全-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">网络安全</span>
              <a class="btn item-more-right">了解</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>了解网站安全等保</li>
                <li>了解服务器（以及政务云）漏扫，安全漏洞修复</li>
                <li>了解防火墙、端口映射和转发等基础防护</li>
              </ul>
            </div>
          </div>

          <!--政务采购-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">政务采购</span>
              <a class="btn item-more-right">熟悉</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>入选兵团、自治区双专家库，熟悉政府招采流程</li>
                <li>政采云专家一枚</li>
                <li>熟悉项目专家评审、国企采购流程</li>
                <li>熟悉项目评标规范和流程</li>
              </ul>
            </div>
          </div>

          <!--其它-->
          <div class="item">
            <header class="item-hd">
              <span class="item-time">其它</span>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>掌握Java、Python、C++、Git、Docker</li>
                <li>了解墨刀绘制原型、视频剪辑（PR）、方案编撰等</li>
                <li>了解传统行业ERP业务</li>
                <li>资深JetBrains用户</li>
                <li>熟悉政采招标</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!--致谢-->
      <section class="thanks">
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">致谢</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd section-bd animate__animated animate__fadeInUp">
          <!--技能:WEB后端开发-->
          <div class="item">
            <h2 style="font-weight: bold;line-height: 24px;margin-top: 10px">
              感谢您在百忙之中阅读这份履历，诚挚的期望能得到面试的机会，希望有荣幸能为公司效力！再次致以我最诚挚的谢意！！
            </h2>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "Content",
  components: {},
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      // 各段经历的展开状态：true=展开。下标对应 openOrClose(id)
      open: {
        99: true, // 兵团文广 2025.11 至今
        0: true,  // 数字新疆
        1: true,  // 兵团文广 2023.11-2025.03
        2: true,  // 数字兵团
        3: true,  // 绿洲驼铃
        4: true,  // 昆仑卫士
        5: true   // 大连东软(实习)
      }
    };
  },
  mounted() {
    $(document).ready(function() {
      if ($("ol:first").css("list-style-type") == "none") {
        /* For IE6/7 only. */
        $("ol ol").each(function(i, ol) {
          ol = $(ol);
          var level1 = ol.closest("li").index() + 1;
          ol.children("li").each(function(i, li) {
            li = $(li);
            var level2 = level1 + "." + (li.index() + 1);
            li.prepend("<span>" + level2 + "</span>");
          });
        });
      }
    });
  },
  methods: {
    openOrClose(id) {
      // 用 $set 保证 Vue 能检测到对象属性变更，替代 $forceUpdate
      this.$set(this.open, id, !this.open[id]);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/content.vue